import { render, staticRenderFns } from "./DeviceBarData.vue?vue&type=template&id=24f0d1a2&scoped=true&"
import script from "./DeviceBarData.vue?vue&type=script&lang=js&"
export * from "./DeviceBarData.vue?vue&type=script&lang=js&"
import style0 from "./DeviceBarData.vue?vue&type=style&index=0&id=24f0d1a2&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f0d1a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
